import FieldCheckbox from './FieldCheckbox';

export default FieldCheckbox;
